export default "__VITE_ASSET__CIokC9Cg__"